_collow.components.CoursesaiGeneratePage = class CoursesaiGeneratePage extends _collow.components.Base {
    root;
    elements;
    params;
    nextStepButton;
    prevStepButton;
    generateCourseButton;
    closeButton;
    editButton;
    currentStepNumber;
    currentStepName;
    stepsInfo;
    isLastStep;
    backButton;
  
    constructor(root, elements, params) {
      super();
  
      this.root = root;
      this.elements = elements;
      this.params = params;
      this.nextStepButton = document.querySelector(".step__btn-next");
      this.prevStepButton = document.querySelector(".step__btn-prev");
      this.generateCourseButton = document.querySelector(".step__btn-generate");
      this.closeButton = document.querySelector(".step__btn-close")
      this.backButton = document.querySelector(".back-link")
      this.stepsInfo = []

      this.nextStepButton.addEventListener("click", this.goToNextStep)
      this.prevStepButton.addEventListener("click", this.goToPreviousStep)
      this.generateCourseButton.addEventListener("click", this.goToFinalStep)
      this.backButton.addEventListener("click", this.returnToOverviewCourseAI)

      this.listen(document, "_reset-changed-flags", this.resetChangedFlags);
      this.listen(document, "_toogle-next-btn", this.toogleNextBtn);
      this.listen(document, "_update-step-info", this.updateStepInfo);
      this.listen(document, "_replace-buttons", this.replaceButtons)

      document.querySelectorAll(".content-section").forEach(section => {
        const stepName = section.getAttribute("step-name")
        const stepNumber = section.getAttribute("step-number").split("-")[1]
        const isActive = section.getAttribute("active")
        this.stepsInfo.push({stepName, stepNumber, isActive})
      })
    }

    resetChangedFlags = () => {
      this.stepsInfo.forEach(step => step.hasChanged = false)
    }

    checkAndMarkStepAsChanged = (index, currentData, newData) => {
        if (index > 3) return
        this.stepsInfo[index].hasChanged = newData !== undefined && JSON.stringify(currentData) !== JSON.stringify(newData)
    }

    goToNextStep = () => {
        this.currentStepNumber = Number(document.querySelector(`.content-section[active="true"]`).getAttribute("step-number").split("-")[1])//ATUALIZA CURRENT STEP
        this.currentStepName = document.querySelector(`.content-section[active="true"]`).getAttribute("step-name")//ATUALIZA CURRENT STEP NAME
        this.dispatch(this.root, "_update-step-info", {step: Number(this.currentStepNumber), completed: true}); //GUARDA INFORMACOES DO STEP ANTERIOR
        this.dispatch(this.root, "_show-next-step", {step: Number(this.currentStepNumber) + 1}); //MOSTRA PROXIMO STEP
        
        const isStepCompleted = this.stepsInfo[Number(this.currentStepNumber)].completed
        !isStepCompleted && this.toogleNextBtn({detail: {step: this.currentStepNumber}})//DESABILITA BOTAO NEXT
        
        this.dispatch(this.root, "_fill-step-circle", {step: this.currentStepNumber, completed: true});//PREENCHE O CIRCULO DO STEP CONCLUIDO
        this.prevStepButton.removeAttribute("hidden")//MOSTRA BOTAO PREV

        if(["Learning goals", "Leerdoelen"].includes(this.stepsInfo[this.currentStepNumber].stepName)) {
            const needsRefresh = this.stepsInfo.filter(step => step?.hasChanged).length > 0
            this.dispatch(this.root, "_init-learning-goals-step", {data: this.stepsInfo, fresh: needsRefresh}); //INICIA O STEP LEARNING
        }

        if(["Select a group", "Kies een groep"].includes(this.stepsInfo[this.currentStepNumber].stepName)) {
            this.dispatch(this.root, "_init-select-group-step"); //INICIA O STEP SELECT A GROUP
        }
  
        this.isLastStep = this.currentStepNumber + 1 == this.stepsInfo.length
        if(this.isLastStep) {
            this.dispatch(this.root, "_replace-buttons", {action: "next"});
        }
    }

    goToPreviousStep = () => {
        this.currentStepNumber = Number(document.querySelector(`.content-section[active="true"]`).getAttribute("step-number").split("-")[1]) - 1 //ATUALIZA CURRENT STEP
        this.currentStepName = document.querySelector(`.content-section[active="true"]`).getAttribute("step-name") - 1//ATUALIZA CURRENT STEP NAME
       
        this.dispatch(this.root, "_update-step-info", {step: Number(this.currentStepNumber)+1, isActive: false}); //GUARDA INFORMACOES DO STEP ANTERIOR
        this.dispatch(this.root, "_show-prev-step", {step: Number(this.currentStepNumber)});//MOSTRA STEP ANTERIOR

        this.currentStepNumber == 1 && this.prevStepButton.setAttribute("hidden", "true") //ESCONDE BOTAO PREV SE O STEP FOR O PRIMEIRO
        this.nextStepButton.removeAttribute("disabled")//MOSTRA BOTAO PREV

        this.isLastStep = this.currentStepNumber + 1 == this.stepsInfo.length
        this.isLastStep && this.dispatch(this.root, "_replace-buttons", {action: "prev"});
    }

    toogleNextBtn = ({detail}) => {
        const { completed, step, data, edit, label } = detail
        
        this.updateStepInfo({detail: {completed, step, data, label}})
        if(edit) {
            this.nextStepButton.removeAttribute("disabled")
        } else if(["Select a group", "Kies een groep"].includes(this.stepsInfo[Number(step)-1].stepName)) {
            this.nextStepButton.removeAttribute("disabled")
        } else if(data === "null" || !data) {
            this.nextStepButton.setAttribute("disabled", "disabled")
        } else if(data) {
            this.nextStepButton.removeAttribute("disabled")
        }
        
        
        if(["Learning goals", "Leerdoelen"].includes(this.stepsInfo[this.currentStepNumber]?.stepName)) {
            const dataSubjectStep = this.stepsInfo.find(step => ["Subject", "Onderwerp"].includes(step.stepName)).data
            
            this.dispatch(this.root, "_save-steps-info", {subject: dataSubjectStep});
        } else if(["Overview", "Overzicht"].includes(this.stepsInfo[this.currentStepNumber]?.stepName)) {
            this.dispatch(this.root, "_get-steps-info", {data: this.stepsInfo});
        }
    }

    updateStepInfo = ({detail}) => {
        const { step:stepNumber, completed, data, isActive, label } = detail
        const index = this.stepsInfo.findIndex((step) => step.stepNumber == stepNumber);
        const section = index !== -1 ? this.stepsInfo[index] : null;
        if (!section?.hasChanged) this.checkAndMarkStepAsChanged(index, section.data, data)
        completed !== undefined && (section.completed = completed)
        data && (section.data = data)
        label && (section.label = label)
        isActive !== undefined && (section.isActive = isActive)
        section && completed && (section.isActive = "false")
    }

    replaceButtons = ({detail}) => {
        const {action} = detail
        if(action === "next") {
            this.nextStepButton.setAttribute("hidden", "true")
            this.generateCourseButton.removeAttribute("hidden")
        } else if(action === "prev") {
            this.nextStepButton.removeAttribute("hidden")
            this.generateCourseButton.setAttribute("hidden", "true")
        } else if(action === "final") {
            this.prevStepButton.setAttribute("hidden", "true")
            this.generateCourseButton.setAttribute("hidden", "true")
            this.closeButton.removeAttribute("hidden")
        }
    }
    
    generateCourse = async () => {
        try {
            const formdata = new FormData();
            formdata.append("topic", this.stepsInfo[0].data);
            formdata.append("level", this.stepsInfo[2].data);
            formdata.append("sector", this.stepsInfo[1].data);
            formdata.append("duration", this.stepsInfo[3].data);
            formdata.append("learning_goals", this.stepsInfo[4].data);
        
            const response = await fetch(this.params.path + "/eduai/generate_course", {
              method: "POST",
              headers: {
                Authorization: localStorage.getItem("token"),
              },
              body: formdata,
            });
        
            if (!response.ok) {
              throw new Error(`Erro na requisição: ${response.status}`);
            }

            return true

          } catch (error) {
            console.error("Erro ao buscar Learning Goals:", error);
            return false
          }
    }

    goToFinalStep = async () => {
        const spinner = document.getElementById("generate_spinner")
        try {
            spinner.style.display = "flex";
            const isSuccessful = await this.generateCourse(); 

            if (isSuccessful) { 
                document.querySelectorAll('.content-section').forEach(sections => sections.setAttribute("active", "false"));
                document.querySelector(".endscreen-container").removeAttribute("hidden");
                this.dispatch(this.root, "_replace-buttons", { action: "final" });
                document.querySelector(".step-panel__sidebar").setAttribute("hidden", "true");
                document.querySelector(".courseai__container-buttons").classList.add("final-screen");
                this.backButton.setAttribute("hidden", "true");
                this.dispatch(this.root, "_fill-step-circle", { step: this.currentStepNumber + 1, completed: true });
            } else {
                console.error("generateCourse falhou ou não retornou positivo.");
                _collow.Notify.error(
                    'Generation was unsuccessful, please try again or reach out to <a href="/admin/supportform" target="_blank" style="color: #007BFF; text-decoration: underline;">Collow support</a>',
                    { duration: 5000 }
                );
            }
        } catch (error) {
            console.error("Erro ao gerar o curso:", error);
            _collow.Notify.error(
                'Generation was unsuccessful, please try again or reach out to <a href="/admin/supportform" target="_blank" style="color: #007BFF; text-decoration: underline;">Collow support</a>',
                { duration: 5000 }
            );
        }
        finally {
            spinner.style.display = "none";
        }
        
    }

    returnToOverviewCourseAI = () => {
        window.location.href = "/coursesaioverview"
    }
};
  
   
  
  
  
  
  
  